import React, { Component } from "react";
import IMask from 'imask';
import { withTranslation } from "react-i18next";
import { Input } from '@material-ui/core';

// import fontFamily from "app/styles/fonts";
import * as styles from './style.css';

const monthMask = IMask.createMask({
  mask: /(^1[012]$)|(^0*[1-9]?$)/
});

const dayMask = IMask.createMask({
  mask: /(^[12]\d$)|(^3[01]$)|(^0*[1-9]?$)/
});

const yearMask = IMask.createMask({
  mask: IMask.MaskedRange,
  from: 1950,
  to: 2100,
});

class UQFormsBirthdayRoundedField extends Component {

  constructor(props) {
    super(props);
    this.state = {
      blured: false,
      day: (props.birthDate || '').split('-')[2],
      month: (props.birthDate || '').split('-')[1],
      year: (props.birthDate || '').split('-')[0],
    };
  }

  getBirthDate = (year, month, day) => {
    if (year || month || day) {
      return `${year}-${month}-${day}`;
    }
    return '';
  };

  onMonthChange = (e) => {
    let month = monthMask.resolve(e.target.value);
    this.setState({ month });
    this.props.onChange(this.getBirthDate(this.state.year, month, this.state.day))
  };

  onDayChange = (e) => {
    let day = dayMask.resolve(e.target.value);
    this.setState({ day });
    this.props.onChange(this.getBirthDate(this.state.year, this.state.month, day));

  };

  onYearChange = (e) => {
    let year = yearMask.resolve(e.target.value);
    this.setState({ year });

    this.props.onChange(this.getBirthDate(year, this.state.month, this.state.day))
  };

  render() {
    return (
      <div className={styles.container}>
        <label className={`${styles.label} font-text`}>
          {this.props.t('month')}
          <div className={styles.inputContainer}>
            <input  style={{ color: this.state.month ? '#252D76' : '#CDCDCD' }}
                        className={`${styles.birthDateInput} font-text`}
                        placeholder={'01'}
                        value={this.state.month}
                        onChange={this.onMonthChange}/>
          </div>
        </label>
        <label className={`${styles.label} font-text`}>
          {this.props.t('day')}
          <div className={styles.inputContainer}>
          <input  style={{ color: this.state.day ? '#252D76' : '#CDCDCD' }}
                      className={`${styles.birthDateInput} font-text`}
                      placeholder={'01'}
                      value={this.state.day}
                      onChange={this.onDayChange}/>
          </div>
        </label>
        <label className={`${styles.label} font-text`}>
          {this.props.t('year')}
          <div className={styles.inputContainer} style={{ minWidth: 62 }}>
          <input  style={{ minWidth: 62, color: this.state.year ? '#252D76' : '#CDCDCD' }}
                  className={`${styles.birthDateInput} font-text`}
                  placeholder={'1990'}
                  value={this.state.year}
                  onChange={this.onYearChange}/>
          </div>
        </label>
      </div>
    )
  }
}

export default withTranslation('cmp-birthdate-input')(UQFormsBirthdayRoundedField);


// WEBPACK FOOTER //
// ./src/app/modules/uq-forms/components/birthday-rounded-field/index.jsx